import ServiceTemplate from '@/components/ServiceTemplate';

export default function PatentOfficeActions() {
  const data = {
    title: 'Patent Office Action Response Services',
    subtitle: 'Expert responses to USPTO patent office actions to advance your application.',
    overviewTitle: 'Understanding Patent Office Actions',
    overviewImage: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=900',
    description: [
      'Patent office actions are official communications from USPTO examiners raising objections or rejections to patent applications. Strategic responses are crucial for overcoming rejections and securing patent grants.',
      'Common issues include prior art rejections, enablement problems, and claim clarity issues. Each requires skilled legal and technical arguments to overcome.',
      'Our experienced patent attorneys analyze office actions, develop strategic responses, and prepare comprehensive arguments to advance your application toward allowance.'
    ],
    benefits: [
      { title: 'Expert Analysis', description: 'Experienced patent attorneys review each action.' },
      { title: 'Strategic Response', description: 'Develop effective arguments and amendments.' },
      { title: 'Technical Expertise', description: 'Understand both legal and technical issues.' },
      { title: 'Claim Optimization', description: 'Amend claims to maximize protection.' },
      { title: 'Interview Support', description: 'Conduct examiner interviews when beneficial.' },
      { title: 'Appeal Preparation', description: 'Prepare appeals when necessary.' }
    ],
    process: [
      { title: 'Analysis & Strategy', description: 'Thorough review of issues and development of comprehensive response strategy.' },
      { title: 'Response Preparation & Filing', description: 'Expert drafting and timely filing of all required responses and documentation.' },
      { title: 'Follow-Up & Resolution', description: 'Monitoring progress and ensuring successful resolution of all matters.' }
    ],
    pricing: [
      {
        name: 'Consultation',
        description: 'Patent evaluation',
        price: '$499',
        period: 'One-time fee',
        features: [
          'Patentability assessment',
          'Prior art search',
          'Patent strategy consultation',
          'Feasibility analysis',
          'Written opinion',
          'Filing recommendations'
        ]
      },
      {
        name: 'Utility Patent',
        description: 'Full patent application',
        price: '$5,999',
        period: '+ USPTO fees ($1,820)',
        featured: true,
        features: [
          'Everything in Consultation',
          'Complete patent drafting',
          'USPTO filing',
          'Office action responses (2 included)',
          'Prior art analysis',
          'Claims optimization',
          'Direct attorney access'
        ]
      },
      {
        name: 'Design Patent',
        description: 'Design protection',
        price: '$1,999',
        period: '+ USPTO fees ($860)',
        features: [
          'Design patent search',
          'Professional patent drawings',
          'Complete application',
          'USPTO filing',
          'Office action response (1 included)',
          'Expedited processing available',
          'Priority support'
        ]
      }
    ],
    faqs: [
      { question: 'What is a patent office action?', answer: 'An official communication from the USPTO examiner raising objections or rejections that must be addressed to obtain a patent.' },
      { question: 'How long do I have to respond?', answer: 'USPTO typically allows 3 months to respond, extendable to 6 months total with extension fees. Missing deadlines results in abandonment.' },
      { question: 'What are common rejections?', answer: 'Common rejections include prior art (anticipation or obviousness), enablement issues, indefiniteness, and double patenting.' },
      { question: 'Can all rejections be overcome?', answer: 'Not all rejections can be overcome, but skilled representation significantly increases success rates through strategic amendments and arguments.' },
      { question: 'What are claim amendments?', answer: 'Amendments modify claims to overcome rejections while preserving as broad protection as possible.' },
      { question: 'Should I interview the examiner?', answer: 'Examiner interviews can clarify issues and reach agreements that expedite allowance, particularly valuable for complex applications.' },
      { question: 'What if my response is denied?', answer: 'You can file further responses, request continued examination (RCE), or appeal to the Patent Trial and Appeal Board (PTAB).' },
      { question: 'How many office actions are typical?', answer: 'Most applications receive 1-3 office actions before final disposition, though complex applications may require more.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
